<template>
  <form novalidate="true" name="additionalData" ref="form" @submit.prevent="submit">
    <div class="chunk" v-for="(elem, index) in Object.keys(schema.properties)" :key="index">

      <form-builder-input-render
        :inputObject="schema.properties[elem]"
        :required="schema.required.includes(elem)"
        :model="model[elem]"
        :name="elem"
        @input="inputUpdate"
      />

      <div v-if="schema.properties[elem].conditional && model[elem]">
        <div class="chunk" v-for="(elemConditional, indexConditional) in Object.keys(conditionalRender(elem, schema.properties[elem].conditional).properties)" :key="indexConditional">
          <form-builder-input-render
            :inputObject="conditionalRender(elem, schema.properties[elem].conditional).properties[elemConditional]"
            :required="schema.required.includes(elemConditional)"
            :model="model[elemConditional]"
            :name="elemConditional"
            @input="inputUpdate"
          />
        </div>
      </div>
    </div>
    <slot></slot>
  </form>
</template>
<script>
import FormBuilderInputRender from './Form/FormBuilderInputRender.vue'

export default {
  name: 'FormBuilder',
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  components: {
    FormBuilderInputRender
  },
  data () {
    return {
      model: {}
    }
  },
  methods: {
    setErrorMessages (elements) {
      elements.forEach(element => {
        element.classList.add('_state_error')
        element.nextSibling.innerHTML = element.validationMessage
        element.nextSibling.classList.add('_state_error')
      })
      elements[0].focus()
      return true
    },
    validateObjectSchema (schema, properties, elements, required) {
      const propKeys = Object.keys(properties)
      const propsRequired = propKeys.filter(key => required.includes(key))
      // Basic types elements {string, number}
      const keysToValidate = propsRequired.filter(name => properties[name].type !== 'array' && properties[name].type !== 'object')
      const elementsToValidate = elements.filter(element => keysToValidate.includes(element.name))
      // Complex types elements {array}
      const arrayProps = propsRequired.filter(name => properties[name].type === 'array')
      let invalidArrayElements = []
      for (let i = 0; i < arrayProps.length; i++) {
        const validatedArrayElements = this.validateArraySchema(properties[arrayProps[i]], elements)
        invalidArrayElements = invalidArrayElements.concat(validatedArrayElements)
      }
      const invalidElements = elementsToValidate.filter(element => !element.validity.valid)
      return invalidElements.concat(invalidArrayElements)
    },
    validateArraySchema (schema, elements) {
      if (!(Array.isArray(schema.items))) {
        if (schema.items.type === 'object') {
          const invalidElements = this.validateObjectSchema(schema.items, schema.items.properties, elements, schema.items.required)
          return invalidElements
        }
      }
    },
    hasInvalidFields (schema, fields, ev) {
      const elements = Array.from(ev.target.elements)
      switch (schema.type) {
        case 'object':
          return this.validateObjectSchema(schema, schema.properties, elements, schema.required)
        case 'array':
          return this.validateArraySchema(schema)
        default:
          return false
      }
    },
    submit (event) {
      const invalidFields = this.hasInvalidFields(this.schema, Object.keys(this.schema.properties), event)
      if (invalidFields.length <= 0) {
        this.$emit('submit', event)
      } else {
        this.setErrorMessages(invalidFields)
      }
    },
    conditionalRender (key, conditionalSchema) {
      const modelValue = this.model[key]
      if (conditionalSchema.oneOf && modelValue) {
        const schema = conditionalSchema.oneOf.find(item => item.properties[key].enum.includes(modelValue))
        if (schema) return schema
        else return { properties: {} }
      }
    },
    inputUpdate (value) {
      this.model[value.name] = value.data
      this.model = Object.assign({}, this.model)
    }
  }
}
</script>
<style>
  .c-control-group__label:before, .u-required:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }
</style>
